import { ICardMotorsportsTeamsRanking } from '@sky-it-livedata/livedata-sports-design-system';

import { competitionNameMap } from '../../../types/data-cards';

import { DataCardTeamRankingQuery } from '../types';
import { ErrorName, WidgetError } from '../../../utils/errors';
import { CardTeamRankingTeamInfo, CreateCardTeamRankingWidgetInputSchema } from 'appsync';
import { intcmpMap } from '../../../utils/intcmp';
import { isValidDataCardTeamRanking } from './typeguards';

export default (obj: DataCardTeamRankingQuery): ICardMotorsportsTeamsRanking => {
  if (isValidDataCardTeamRanking(obj)) {
    CreateCardTeamRankingWidgetInputSchema().parse(obj.data.getCardTeamRankingWidget, {reportInput: true});
    const { customCompetitionName, rankingLink, teams } = obj?.data.getCardTeamRankingWidget;

    return {
      competitionName: `Team ${competitionNameMap.get(customCompetitionName)}`,
      teams: teams!.map((teamObject) => {
        const team = teamObject as CardTeamRankingTeamInfo;
        return {
          targetUrl: team.customTeamPageUrl,
          position: team.pos,
          logoUrl: team.logoUrl,
          teamUrl: team.customTeamPageUrl,
          points: team.pts,
          teamName: team.customTeamName,
          trackingData: { intcmp: intcmpMap.dataCardTeamRanking.detailLink },
        };
      }),
      readMoreLink: rankingLink,
      trackingData: { 'analytics-element': `card-ranking-motorsport-formula1-team` },
      cardCtaTrackingData: {
        intcmp: intcmpMap.dataCardTeamRanking.viewAllCta,
      },
    } as ICardMotorsportsTeamsRanking;
  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in DataCardTeamRankingQuery object',
      data: obj
    });
  }
};
